import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import {Wrapper, Text, IconWrapper, Image} from '../styles';
import appConfig from '../../../../app-config';

const OrderSubmitted = ({orderStatus, isIconShowing, imageShowing}) => {
  return (
    <Wrapper>
      <IconWrapper>
        {appConfig.orderStatusImages &&
        appConfig.orderStatusImages.order_submitted ? (
          <Image src={appConfig.orderStatusImages.order_submitted} />
        ) : (
          <Icon
            className={
              (appConfig.orderStatusIcons &&
                appConfig.orderStatusIcons.order_submitted) ||
              'fa fa-check-circle'
            }
          />
        )}
      </IconWrapper>
      <Text id="OrderSubmitted-OrderPlaced">Your order has been placed</Text>
    </Wrapper>
  );
};

export default OrderSubmitted;
